import React from "react";

export default function LoadingSpinner(border) {
  return (
    <div className="spinner-container">
      <div className="loading-spinner">
      </div>
    </div>
  );
}